import Main from './js/main';

function App() {
  return (

    <div>
   <Main></Main>
    </div>
    
  );
}




export default App;
